import React, { forwardRef, useImperativeHandle } from 'react';
import { useTheme } from '@/context/ThemeContext';
import { useOnScreen } from '@/hooks/useOnScreen';
import useDiscoveryFeed from '@/hooks/useDiscoveryFeed';
import useDiscoveryCatalog from '@/hooks/useDiscoveryCatalog';
import DiscoveryFeatureSection from './DiscoveryFeatureSection';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';
import DiscoveryFeedLayout from './DiscoveryFeedLayout';
import LocalBriefing from './LocalBriefing';
import RecentDiscovery from './RecentDiscovery';
import useDiscoveryExperience from '@/hooks/useDiscoveryExperience';

const HomeDiscoveryFeed = forwardRef(function HomeDiscoveryFeed({ enabled, onSelect }, ref) {
  const { theme } = useTheme();
  const palette = getCatalogPalette(theme);
  const [visibilityRef, visible] = useOnScreen({ rootMargin: '300px' });
  const experience = useDiscoveryExperience(enabled && visible);
  const feed = useDiscoveryFeed({ enabled: enabled && visible && experience.ready, history: experience.history });
  const { key: contextKey, ...feedView } = feed;
  const catalog = useDiscoveryCatalog({ enabled: enabled && visible && feed.items.length >= 6, contextKey });
  useImperativeHandle(ref, () => ({ loadMore: () => { if (!feed.error) feed.loadMore(); } }), [feed.loadMore, feed.error]);
  if (!enabled) return null;
  return <DiscoveryFeedLayout ref={visibilityRef} palette={palette} {...feedView} onLoadMore={feed.loadMore}
    onSeen={experience.record} onSelect={item => { experience.record(item, 'used'); onSelect(item.prompt); }}
    renderFeature={({ group, columns, cardWidth }) => {
      const kind = ['tasks', 'tools', 'maps'][group % 3];
      return <DiscoveryFeatureSection kind={kind} items={catalog[kind]} page={Math.floor(group / 3)} palette={palette} columns={columns} cardWidth={cardWidth} />;
    }}>
    <RecentDiscovery mode="chat" palette={palette} onUse={experience.record} />
    <LocalBriefing enabled={enabled && visible} contextKey={feed.key} />
  </DiscoveryFeedLayout>;
});
export default HomeDiscoveryFeed;
